import { createService } from '@/helpers/hasura'

import gql from 'graphql-tag'

import { CartItemFragment } from '@/helpers/api/fragments'

const output = `
  ...CartItem
  product {
    code
    short_description
  }
  customer {
    legal_name
  }
  user {
    name
  }
`
const fragments = gql`
  ${CartItemFragment}
`

const allowedFields = [
  'quantity',
  'specifications',
  'reference',
  'file_id',
  'shipping_address_id',
  'comments',
  'product_id',
  'updated_at',
  'created_at'
]

export default config => {
  const { client } = config
  const service = createService({
    ...config,
    table: 'cart_item',
    defaultFilters: [],
    defaultOutput: output,
    defaultFragments: fragments,
    allowedFields
  })

  return {
    ...service,
    cartItemByUserIdSubscription: payload => {
      const {
        user_id = () => {
          throw new Error("cartItemByUserIdSubscription: 'user_id' is required")
        }
      } = payload

      const query = gql`
        subscription items($userId: uuid!){
          items: cart_item(where : { user_id: { _eq: $userId}){
            ${output}
          }
        }
        ${fragments}
      `

      const observer = client.subscribe({
        query,
        variables: {
          userId: user_id
        }
      })

      return observer
    }
  }
}
